import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <header>
            <nav>
                <Link to="/">About</Link>
                <Link to="/portfolio">Portfolio</Link>
                <a href={process.env.PUBLIC_URL + "/cv/cv_updated.pdf"} target="_blank" rel="noopener noreferrer">CV</a>
                <Link to="/blog">Blog</Link> {/* Uncommented blog link */}
            </nav>
        </header>
    );
};

export default Header;